<template>
    <div class="max">
        <div  v-if="formLoading">
            <div class="d-flex justify-content-center">
                <b-spinner label="Spinning"></b-spinner>
            </div>
        </div>
        <div v-else>
            <b-col cols="12"  class="mb-4">
                <b-card class="shadow-sm">
                    <ValidationObserver ref="formModalValidate">
                        <b-row>
                            <b-col cols="12" sm="6" class="mb-3">
                                <ValidationProvider name="classroom_id" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('classroom')" class="font-weight-bold">
                                        <classroom-selectbox
                                            v-model="formData.classroom_id"
                                            :validate-error="errors[0]"
                                            :class="{ 'is-invalid': errors[0] }"
                                        />
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <!-- Day Selection -->
                            <b-col cols="12" sm="6" class="mb-3">
                                <ValidationProvider name="day" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('day')" class="font-weight-bold">
                                        <DaysSelectbox
                                            v-model="formData.day"
                                            :validateError="errors[0]"
                                            :class="{ 'is-invalid': errors[0] }"
                                        />
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <!-- Start Time -->
                            <b-col cols="12" sm="6" class="mb-3">
                                <ValidationProvider name="start_time" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('start_time')" class="font-weight-bold">
                                        <time-picker
                                            type="text"
                                            :is-range="false"
                                            v-model="formData.start_time"
                                            :validate-error="errors[0]"
                                            :class="{ 'is-invalid': errors[0] }"
                                        />
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <!-- End Time -->
                            <b-col cols="12" sm="6" class="mb-3">
                                <ValidationProvider name="end_time" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('end_time')" class="font-weight-bold">
                                        <time-picker
                                            type="text"
                                            :is-range="false"
                                            v-model="formData.end_time"
                                            :validate-error="errors[0]"
                                            :class="{ 'is-invalid': errors[0] }"
                                        />
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <!-- Submit Button -->
                            <b-col cols="12" class="d-flex justify-content-end mt-3">
                                <b-button
                                    variant="primary"
                                    class="px-4"
                                    @click="createForm"
                                    :disabled="formProcess"
                                >
                                    {{ $t('add') }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </ValidationObserver>
                </b-card>
            </b-col>
            <b-col cols="12">
                <div v-if="sections && sections.length > 0">
                    <b-table bordered striped hover
                             :fields="sectionFields"
                             :items="sections"
                    >
                        <template #cell(date)="{item}">
                            <span>{{item.date}}</span>
                        </template>
                        <template #cell(update)="data">
                            <b-button variant="primary" size="sm" @click="showUpdateForm(data.item.id,data.item)">
                                {{ $t('edit').toUpper() }}
                            </b-button>
                        </template>
                    </b-table>
                </div>
                <div v-else>
                    <div class="border p-4 rounded-sm">
                        {{ $t('no_result') }}
                    </div>
                </div>
            </b-col>

        </div>
        <CommonModal ref="showModal" size="md" :on-hide-only-x="true"
                     @bHideModalHeaderClose="formDataClear">
            <template v-slot:CommonModalTitle>
                <div>{{ $t("update").toUpper() }}</div>
            </template>
            <template v-slot:CommonModalContent>
                <b-row>
                    <b-col cols="12">
                        <ValidationObserver ref="updateValidate">
                            <b-row>
                                <b-col cols="12" sm="6" class="mb-3">
                                    <ValidationProvider name="classroom_id" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('classroom')" class="font-weight-bold">
                                            <classroom-selectbox
                                                v-model="updateData.classroom_id"
                                                :validate-error="errors[0]"
                                                :class="{ 'is-invalid': errors[0] }"
                                            />
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>

                                <!-- Day Selection -->
                                <b-col cols="12" sm="6" class="mb-3">
                                    <ValidationProvider name="day" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('date')" class="font-weight-bold">
                                            <SelectDate
                                                v-model="updateData.date"
                                                :validateError="errors[0]"
                                                :class="{ 'is-invalid': errors[0] }"
                                            />
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>

                                <!-- Start Time -->
                                <b-col cols="12" sm="6" class="mb-3">
                                    <ValidationProvider name="start_time" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('start_time')" class="font-weight-bold">
                                            <time-picker
                                                type="text"
                                                :is-range="false"
                                                v-model="updateData.start_time"
                                                :validate-error="errors[0]"
                                                :class="{ 'is-invalid': errors[0] }"
                                            />
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>

                                <!-- End Time -->
                                <b-col cols="12" sm="6" class="mb-3">
                                    <ValidationProvider name="end_time" rules="required" v-slot="{ valid, errors }">
                                        <b-form-group :label="$t('end_time')" class="font-weight-bold">
                                            <time-picker
                                                type="text"
                                                :is-range="false"
                                                v-model="updateData.end_time"
                                                :validate-error="errors[0]"
                                                :class="{ 'is-invalid': errors[0] }"
                                            />
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>

                                <!-- Submit Button -->
                                <b-col cols="12" class="d-flex justify-content-end mt-3">
                                    <b-button
                                        variant="primary"
                                        class="px-4"
                                        @click="updateForm"
                                        :disabled="formProcess"
                                    >
                                        {{ $t('save') }}
                                    </b-button>
                                </b-col>
                            </b-row>
                        </ValidationObserver>
                    </b-col>
                </b-row>

            </template>
        </CommonModal>

    </div>
</template>

<script>
    // Components
    import TimePicker from "@/components/elements/TimePicker.vue";
    // Services
    import SectionService from "@/services/SectionService"

    // Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    import qs from "qs";
    import ClassroomSelectbox from "@/components/interactive-fields/ClassroomSelectbox.vue";
    import DaysSelectbox from "@/components/interactive-fields/DaysSelectbox.vue";
    import moment from "moment";

    export default {
        components: {
            DaysSelectbox,
            ClassroomSelectbox,
            TimePicker,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                id:null,
                sectionFields: [
                    {
                        key: 'classroom_name',
                        label: this.$t('classroom').toUpper(),
                        sortable: true
                    },
                    {
                        key: 'date',
                        label: this.$t('date').toUpper(),
                        sortable: true
                    },
                    {
                        key: 'start_time',
                        label: this.$t('start_time').toUpper(),
                        sortable: true
                    },
                    {
                        key: 'end_time',
                        label: this.$t('end_time').toUpper(),
                        sortable: true
                    },
                    {
                        key: 'update',
                        label: '',
                        sortable: true,
                        tdClass:'width-50 text-center'
                    }
                ],
                updateData:{
                    start_time:null,
                    end_time:null,
                    date:null,
                    classroom_id:null,
                },
                sections:[],
                formData: {},
                formLoading: false,
                formProcess: false
            }
        },
        created() {
            if (this.formId) {
                this.getSection(this.formId);
            }
        },
        methods: {
            formDataClear() {
                this.formData = {}
                this.id = null;
            },

            getSection() {
                this.formLoading = true
                const config={
                    params:{
                        filter:{
                            section_id: this.formId,
                        },
                        sort:'date',
                    },
                    paramsSerializer: (params) =>
                        qs.stringify(params, { encode: false }),
                }
                SectionService.dailyCourseSchedules(config)
                              .then(response => {
                                  this.sections = response.data.data;
                              })
                              .catch(e => {
                                  this.showErrors(e)
                              })
                              .finally(() => {
                                  this.formLoading = false;
                              })
            },

            async createForm() {
                if(this.checkPermission('dailycourseschedule_weeklycourseschedulestore')) {
                    const isValid = await this.$refs.formModalValidate.validate();
                    if (isValid) {
                        this.formProcess = true;
                        let form = {
                            section_id: this.formId,
                            day: this.formData.day,
                            start_time: this.formData.start_time,
                            end_time: this.formData.end_time,
                            classroom_id: this.formData.classroom_id,
                        }
                        SectionService.AddDailyCourseSchedules(form)
                            .then(response => {
                                this.formDataClear();
                                this.$toast.success(this.$t('api.' + response.data.message));
                                this.$refs.formModalValidate.reset();
                                this.getSection();
                            })
                            .catch(e => {
                                this.showErrors(e)
                            })
                            .finally(() => {
                                this.formProcess = false;
                            })
                    }
                }else {
                    this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
                }

            },
            showUpdateForm(id,selectedRow) {
                this.id = id;
                this.updateData={
                    classroom_id:selectedRow.classroom_id,
                    start_time:selectedRow.start_time,
                    end_time:selectedRow.end_time,
                    instructor_id:selectedRow.instructor_id,
                    date:moment(selectedRow.date).format('MM/DD/YYYY'),
                    semester_id:selectedRow.semester_id,
                    course_id:selectedRow.course_id,
                    section:selectedRow.section,
                    allow_classroom_overlap:selectedRow.allow_classroom_overlap,
                    allow_instructor_overlap:selectedRow.allow_instructor_overlap,
                }
                this.$refs.showModal.$refs.commonModal.show()
            },
            async updateForm(){
                const isValid=await this.$refs.updateValidate.validate();
                 if(this.checkPermission('dailycourseschedule_update')){
                     if (!isValid)return
                   SectionService.UpdateDailyCourseSchedules(this.id,this.updateData)
                       .then(response => {
                           this.$toast.success(this.$t('api.' + response.data.message));
                           this.getSection();
                           this.$refs.showModal.$refs.commonModal.hide()

                       })
                       .catch(error => {
                           this.$toast.error(this.$t('api.' + error.data.message));
                       });
               } else {
                   this.$toast.error(this.$t('you_are_not_authorized_for_this_operation'))
               }
            }
        }
    }
</script>

